/**
 * Map over items with a fixed concurrency limit (avoids browser
 * net::ERR_INSUFFICIENT_RESOURCES from unbounded Promise.all fan-out).
 */
export async function mapWithConcurrency(items, concurrency, mapper) {
  const list = Array.isArray(items) ? items : [];
  if (!list.length) return [];

  const limit = Math.max(1, Math.min(Number(concurrency) || 1, list.length));
  const results = new Array(list.length);
  let nextIndex = 0;

  async function worker() {
    while (nextIndex < list.length) {
      const index = nextIndex;
      nextIndex += 1;
      results[index] = await mapper(list[index], index);
    }
  }

  await Promise.all(Array.from({ length: limit }, () => worker()));
  return results;
}

export async function mapSettledWithConcurrency(items, concurrency, mapper) {
  return mapWithConcurrency(items, concurrency, async (item, index) => {
    try {
      const value = await mapper(item, index);
      return { status: "fulfilled", value };
    } catch (reason) {
      return { status: "rejected", reason };
    }
  });
}
